{
    "account": "Konto",
    "add_bookmark": "Dodaj wiadomość do zakładek",
    "add_date": "Dodaj datę",
    "ago": "{{duration}} temu",
    "api_key": "Klucz API",
    "ask_delete_message": "Czy na pewno chcesz usunąć tą wiadomość?",
    "bookmark_added": "Dodano wiadomość do zakładek.",
    "bookmarks": "zakładki",
    "cancel": "Anuluj",
    "confirm_password_placeholder": "potwierdź hasło",
    "connect": "Połączenie",
    "daily": "Codziennie",
    "default_group": "Domyślna grupa",
    "delete": "Usuń",
    "edit": "Edytuj",
    "email": "E-mail",
    "error": "Wystąpił błąd",
    "forgot_password": "Nie pamiętasz hasła?",
    "groups": "Grupy",
    "has_joined": "dołączył/a",
    "has_left": "opuścił/a",
    "hourly": "Co godzinę",
    "invitation_link": "Link zapraszający",
    "in": "w",
    "just_now": "Przed chwilą",
    "lang": "język",
    "login_input": "Wybierz login",
    "login_placeholder": "Adres e-mail",
    "login": "Zaloguj się",
    "logout": "Wyloguj się",
    "monthly": "Co miesiąc",
    "name_input": "Wybierz nazwę",
    "name": "Nazwa",
    "new_password_placeholder": "nowe hasło",
    "next_coms": "Zobacz następne komentarze",
    "none": "Brak",
    "notification_emails": "Powiadomienia e-mail",
    "notifications": "powiadomienia",
    "password": "Hasło",
    "password_placeholder": "Hasło",
    "passwords_dont_match": "Hasła nie pasują do siebie",
    "previous_coms": "Zobacz poprzednie komentarze",
    "public_link": "link publiczny",
    "remove_bookmark": "Usuń wiadomość z zakładek",
    "replies_one": "{{count}} odpowiedź",
    "replies_other": "{{count}} odpowiedzi",
    "reply": "odpowiedz",
    "reset_password_title": "Zresetuj swoje hasło",
    "save_changes": "Zapisz zmiany",
    "settings": "Ustawienia",
    "signup": "Zarejestruj się",
    "submit": "Prześlij",
    "to": "do",
    "upload_image": "Dodaj zdjęcia",
    "upload_music": "Dodaj muzykę",
    "upload_pdf": "Dodaj PDF",
    "upload_video": "Dodaj film",
    "User not found": "Nie znaleziono użytkownika",
    "users": "użytkownicy",
    "weekly": "Co tydzień"
}
